define("shared/decorators/track-call-duration", ["exports", "@ember/application", "@ember/debug", "lodash"], function (_exports, _application, _debug, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/application",0,"@ember/debug",0,"lodash"eaimeta@70e063a35619d71f
  function hasPerformanceTracking(obj) {
    return !(0, _lodash.isNull)(obj) && (0, _lodash.isObject)(obj) && 'performanceTracking' in obj;
  }
  function isConstructable(obj) {
    return !(0, _lodash.isNull)(obj) && (0, _lodash.isObject)(obj) && 'constructor' in obj;
  }
  function _getService(self) {
    if (hasPerformanceTracking(self)) {
      return self.performanceTracking;
    }
    try {
      const owner = (0, _application.getOwner)(self);
      if (!owner) {
        throw new Error('Unable to get owner');
      }
      const service = owner.lookup('service:performance-tracking');
      return service;
    } catch (error) {
      (false && !(false) && (0, _debug.assert)('This decorator must be used in an Ember container (service, route, controller, component, etc.)'));
    }
  }

  /**
   * Tracks how long the target method/getter takes to run.
   * The duration is tracked via the {@link PerformanceTrackingService}
   */
  function trackCallDuration(eventName) {
    return function (target, propertyKey, descriptor) {
      let methodType = null;
      let _eventName = eventName;
      if ('get' in descriptor) {
        methodType = 'get';
      } else if ('value' in descriptor) {
        methodType = 'value';
      }
      if (!methodType) {
        (false && !(false) && (0, _debug.assert)('debug cannot be performed on target without descriptor value or getter'));
      }
      const originalMethod = descriptor[methodType];
      const targetName = isConstructable(target) ? target.constructor.name : '';
      const methodName = originalMethod.name === 'CPGETTER_FUNCTION' ? propertyKey : originalMethod.name;
      _eventName = `${targetName}: ${methodName}`;
      const isAsync = originalMethod.constructor.name === 'AsyncFunction';
      if (isAsync) {
        descriptor[methodType] = async function () {
          const performanceTracking = _getService(this);
          const endMeasurement = performanceTracking?.startMeasurement(_eventName);
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          const result = await originalMethod.apply(this, args);
          endMeasurement?.();
          return result;
        };
      } else {
        descriptor[methodType] = function () {
          const performanceTracking = _getService(this);
          const endMeasurement = performanceTracking?.startMeasurement(_eventName);
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          const result = originalMethod.apply(this, args);
          endMeasurement?.();
          return result;
        };
      }
      return descriptor;
    };
  }
  var _default = _exports.default = trackCallDuration;
});